<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Search</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'download' }">
          <v-list-item-action>
            <v-icon>mdi-download</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Download</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
<!-- 
    <v-app-bar
      color="secondary"
      app
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>CTFL Corpus Browser</v-toolbar-title>
    </v-app-bar> -->

    <v-content>
        <router-view></router-view>
    </v-content>
    <v-footer
      app
      color="secondary"
    >
      <span class="white--text">&copy; 2020 Centre for Thai as a Foreign Language, Faculty of Arts, Chulalongkorn University</span>
    </v-footer>
  </v-app>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
    methods: {
      ...mapActions({
        loadCorpus: 'loadCorpus'
      })
    },
    async mounted() {
      await this.loadCorpus()
    }
  }
</script>
